import { Container, Typography, Box, Stack } from "@mui/material";
import React, { useState, useEffect } from "react";
import ServicesCard from "../Components/ServicesCard";
import db from "../DbFile.json";
import { useTranslation } from "react-i18next";
import pic from "../Media/food-delivery.png";

export default function EatAnyTime({ setTheState }) {
  const [el, setEl] = useState(db.first_array);
  const [Qs, setQs] = useState(db.Rdie_Q);
  const { t } = useTranslation();
  useEffect(() => {
    setTheState(false);
  }, []);
  return (
    <Container>
      <div className="h111">Coming Soon</div>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img
          alt="img8888"
          src={pic}
          style={{ height: "300px", width: "300px", objectFit: "cover" }}
        />
      </Box>
      <Box
        sx={{
          marginTop: "5%",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Stack>
          <Typography
            sx={{
              fontWeight: "bold",
              fontSize: "40px",
              color: "#1D2877",
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {t("Explore more with Mashawiri")}
          </Typography>
          {el && <ServicesCard el={el.filter((el) => el.id !== 2)} />}
        </Stack>
      </Box>
    </Container>
  );
}
